import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import { client } from "../../auth/Client";
import FloatingAlert from "../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../helpers/bgSliders";
import { setLoginData } from "../../helpers/helpers";
import { getPhoneLoginEndpoint } from "./phoneLoginConfig";
import "./PhoneLoginPage.scss";
import PhoneLoginPageDisplay from "./PhoneLoginPage.styled";

const randomBg = bgSliders.getRandomBg();
const urlGamesroid = window.location.hostname.includes("gamezroid");

function isLoginSuccess(data) {
  return data && (data.status === true || data.success === true);
}

function getErrorMessage(error, fallback) {
  if (error && error.response && error.response.data) {
    const data = error.response.data;
    return data.message || data.error || data.msg || fallback;
  }

  return (error && error.message) || fallback;
}

class PhoneLoginPage extends Component {
  constructor() {
    super();
    this.state = {
      phone: "",
      errors: false,
      errorMsg: "",
      loading: false,
      phonePlaceholder: urlGamesroid ? "gamesplaceholder" : "enter_phone_number",
    };
  }

  async componentDidMount() {
    if (await client.auth()) {
      this.props.history.push("/");
    }
  }

  onPhoneChange = (value) => {
    this.setState({
      phone: value.replace(/[^0-9]/g, ""),
      errors: false,
    });
  };

  saveSession = (data) => {
    setLoginData(
      data.user_id,
      data.token,
      data.user_name,
      data.photo || data.user_photo,
      data.operator_id,
      data.user_email || data.email,
      data.msisdn,
      data.subscriptionContractId
    );
  };

  redirectAfterLogin = () => {
    if (localStorage.getItem("gameURL")) {
      this.props.history.push(localStorage.getItem("gameURL"));
      return;
    }

    this.props.history.push("/");
  };

  login = async (e) => {
    e.preventDefault();

    const { phone } = this.state;
    const loginUrl = getPhoneLoginEndpoint(window.location.hostname);

    if (!phone) {
      this.setState({
        errors: true,
        errorMsg: this.props.t("enter_phone_number"),
      });
      return;
    }

    if (!loginUrl) {
      this.setState({
        errors: true,
        errorMsg: this.props.t("Something went wrong"),
      });
      return;
    }

    this.setState({ loading: true, errors: false });

    try {
      const response = await axios.post(loginUrl, { phone });
      const data = response.data;

      if (isLoginSuccess(data)) {
        this.saveSession(data);
        this.redirectAfterLogin();
        return;
      }

      this.setState({
        errors: true,
        errorMsg: this.props.t(
          data.message || data.error || data.msg || "invalid_phone_password"
        ),
      });
    } catch (error) {
      this.setState({
        errors: true,
        errorMsg: this.props.t(
          getErrorMessage(error, "Something went wrong")
        ),
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { errors, errorMsg, phone, loading, phonePlaceholder } = this.state;
    const { t } = this.props;

    return (
      <PhoneLoginPageDisplay className="" bgImg={randomBg}>
        <div className="formPage">
          <form onSubmit={this.login}>
            <div className="formsLayout">
              <div className="header">
                <Link to="/">
                  <div className="logo" />
                </Link>
              </div>

              <div className="center">
                <div className="form">
                  <div className="iconInput">
                    <i className="icon phone" />
                    <input
                      type="text"
                      className="input"
                      value={phone}
                      autoComplete="phone"
                      placeholder={t(phonePlaceholder)}
                      onChange={(e) => this.onPhoneChange(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="footer">
                <div className="normBtn">
                  <button className="btn" type="submit" disabled={loading || !phone}>
                    <Trans>sign_in</Trans>
                  </button>
                </div>

                <p>
                  <Trans>login.don’t_have_account</Trans>{" "}
                  <Link to="signup">
                    <Trans>sign_up</Trans>
                  </Link>
                </p>
              </div>
            </div>
          </form>

          {errors ? <FloatingAlert type="error">{errorMsg}</FloatingAlert> : null}
        </div>
      </PhoneLoginPageDisplay>
    );
  }
}

export default withTranslation()(PhoneLoginPage);
